import { Component, OnInit, NgZone } from '@angular/core';
import { ActivatedRoute, Routes, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { NotifierService } from '../../shared/notifier/notifier.service';
import { BuyOrderService } from '../../services/buy-order.service';
import { ListofvaluesService } from '../../services/listofvalues.service';
import { ProviderService } from '../../services/provider.service';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import * as fileSaver from 'file-saver';
import { LocalDataSource } from 'ng2-smart-table';
import { MatDialog } from '@angular/material/dialog';
import { AlertComponent } from '../../../shared';
import { CreateBuyOrderModalComponent } from './createBuyOrderModal/createBuyOrderModal.component';
import { WorkOrderService } from '../../services/work-order.service';
import { BudgetService } from '../../services/budget.service';
import { PDFService } from '../../services/pdf.service';
import { InternalService } from '../../services/internal.service'

@Component({
  selector: 'app-new-buy-order',
  templateUrl: 'new-buy-order.component.html',
  styleUrls: ['new-buy-order.component.scss'],
  providers: [BuyOrderService, ListofvaluesService, ProviderService, WorkOrderService, BudgetService, PDFService]
})
export class NewBuyOrderComponent implements OnInit {
  workOrderData: any;
  budgetData: any;
  paramId: number;
  budgetId: number;
  provider_email: string = null;
  fromBudget: boolean = false;
  buyOrderHeaderData: any = {};
  buyOrderDetailData: any = [];
  dataParams: any = undefined;
  tableSettingsBuyOrderDetail: any = undefined;
  dataSourceBuyOrderDetail: any = undefined;
  tableDataBuyOrderDetail: any = {};
  ldvMoney: any;
  providerName: string;
  listProviders: any = [];
  buyOrderHeaderPrice: any;
  priceWithTax: any = 0;
  tax_text = 'IGV';
  filteredOptions: Observable<string[]>;
  myControlProviders = new FormControl();
  options: string[] = ['One', 'Two', 'Three'];
  tax_percentage = '18%';
  tax_val: any = 0;
  providerComercialNameSelected: string;
  total: any = 0;
  dataToSend: any;
  perPage = 10;
  settings = {
    pager: { display: true, perPage: this.perPage },
    noDataMessage: 'No hay datos que mostrar.', columns: undefined,
    actions: {
      add: false, delete: false, position: 'right', edit: false, columnTitle: 'Acciones',
      custom: [
        { name: 'editar', title: `<div class="editCustomButton">Editar</div>` },
        { name: 'eliminar', title: `<div class="editCustomButton">Eliminar</div>` }
      ]
    }
  };

  constructor(
    private route: ActivatedRoute,
    private listofvaluesService: ListofvaluesService,
    private notifierService: NotifierService,
    private buyOrderService: BuyOrderService,
    private providerService: ProviderService,
    private budgetService: BudgetService,
    private workOrderService: WorkOrderService,
    private pdfService: PDFService,
    public dialog: MatDialog,
    private internalService: InternalService,
    private routes: Router, private zone: NgZone) {
    this.listofvaluesService.getLdvByCode('TBWA-MONEY').subscribe((result) => {
      this.ldvMoney = result;
    });
    this.providerService.listProviders().subscribe((result: any) => {
      this.listProviders = result;

      this.listProviders.sort(function (a, b) {
        if (a.comercial_name < b.comercial_name) { return -1; }
        if (a.comercial_name > b.comercial_name) { return 1; }
        return 0;
      })


    });
    this.tableDataBuyOrderDetail = {
      columns: {
        description: { title: 'Descripción' },
        price_string: { title: 'Precio' }
      },
      data: {}
    };
    this.route.params.subscribe((params) => {
      if (params['bhid']) {
        this.fromBudget = true;
        this.budgetId = params['bhid'];
        this.budgetService.getOneBudget(this.budgetId).subscribe((resultBudget) => {
          this.budgetData = resultBudget;
          this.workOrderService.getWorkOrder(this.budgetData.work_order_id).subscribe((resultWO) => {
            this.workOrderData = resultWO;
            this.internalService.internalListener.subscribe(
              (data) => {
                if (data.from == 'ocBudgetModal' && data.dataList) {
                  this.buyOrderHeaderData.id_provider = data.dataList[0].provider_id;
                  this.buyOrderHeaderData.tax = this.budgetData.tax;
                  this.buyOrderHeaderData.currency = this.budgetData.currency;
                  this.buyOrderHeaderData.id_budget_header = this.budgetId;
                  this.buyOrderHeaderData.others = 0;
                  this.listofvaluesService.getLdvByCode('TBWA-LEGALTEXT-BUYORDER').subscribe((textResult: any) => {
                    this.buyOrderHeaderData.terms = textResult[0].value;
                  });

                  let details = [];

                  data.dataList.forEach(element => {
                    let line = {
                      description: element.description,
                      price: element.cost_provider,
                      action_backend: 'C'
                    }
                    details.push(line);
                  });

                  this.buyOrderDetailData = details;

                  this.getTableData(this.buyOrderDetailData);

                }
              }
            );
          })
        })
      } else if (params['id']) {
        this.paramId = params['id'];

        this.buyOrderService.getBuyOrderHeader(this.paramId).subscribe((buyOrder: any) => {
          this.buyOrderHeaderData = buyOrder;
          console.log('buy ord', this.buyOrderHeaderData)
          const found = this.listProviders.find((item) => {
            return item.id == buyOrder.id_provider;
          });
          //this.providerName = found.comercial_name;
          this.providerName = buyOrder.prov_comercial_name;
          console.log('buy ord', this.buyOrderHeaderData)
          //this.provider_email = found.email;
          this.provider_email = buyOrder.prov_email;
          if (this.buyOrderHeaderData.others == null || this.buyOrderHeaderData.others == undefined) {
            this.buyOrderHeaderData.others = 0;
          }
          

          if (this.buyOrderHeaderData.id_budget_header) {
            this.fromBudget = true;
            this.budgetService.getOneBudget(this.buyOrderHeaderData.id_budget_header).subscribe((resultBudget) => {
              this.budgetData = resultBudget;
              this.budgetId = this.budgetData.id;
              this.workOrderService.getWorkOrder(this.budgetData.work_order_id).subscribe((resultWO) => {
                this.workOrderData = resultWO;
              });
            });
          }

          this.buyOrderService.getBuyOrderDetails(this.paramId).subscribe((buyOrderDetails: any = []) => {
            this.buyOrderDetailData = buyOrderDetails;
            this.buyOrderDetailData.forEach(element => {
              element.action_backend = 'E';
            });
            this.getTableData(this.buyOrderDetailData);

          });

        });
      } else {
        this.paramId = undefined;
        this.buyOrderHeaderData.id_provider = 1;
        this.buyOrderHeaderData.tax = 1;
        this.buyOrderHeaderData.currency = 7;
        this.buyOrderHeaderData.product = '';
        this.buyOrderHeaderData.project = '';
        this.buyOrderHeaderData.others = 0;
        this.listofvaluesService.getLdvByCode('TBWA-LEGALTEXT-BUYORDER').subscribe((textResult: any) => {
          this.buyOrderHeaderData.terms = textResult[0].value;
        });
      }
    });


  }

  updateVals() {
    this.getTableData(this.buyOrderDetailData);
  }
  updateCurr() {
    console.log(this.buyOrderHeaderData.currency);
    if (this.buyOrderHeaderData.currency==7){
      this.listofvaluesService.getLdvByCode('TBWA-LEGALTEXT-BUYORDER').subscribe((textResult: any) => {
        this.buyOrderHeaderData.terms = textResult[0].value;
      });
  
    }else{
      this.listofvaluesService.getLdvByCode('TBWA-LEGALTEXT-BUYORDER-USD').subscribe((textResult: any) => {
        this.buyOrderHeaderData.terms = textResult[0].value;
      });
    }
   
    this.getTableData(this.buyOrderDetailData);
  }
  ngOnInit() {

    this.filteredOptions = this.myControlProviders.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );

    this.getTableData([]);

  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    //console.log(this.listProviders.filter(provider => provider.comercial_name.toLowerCase().includes(filterValue)))
    //console.log(this.options.filter(provider => provider.toLowerCase().includes(filterValue)))
    return this.listProviders.filter(provider => provider.comercial_name.toLowerCase().includes(filterValue));
  }


  copyObject(obj): object {
    return JSON.parse(JSON.stringify(obj));
  }
  exportPDF() {
    this.notifierService.systemNotify({
      title: 'Espere un momento',
      message: 'Descargando PDF',
      type: 'info',
      duration: 20000
    });

    this.buyOrderHeaderData.created_date = new Date(this.buyOrderHeaderData.created_date).toLocaleString().split(" ")[0];

    for (let index = 0; index < this.buyOrderDetailData.length; index++) {
      this.buyOrderDetailData[index].index = index + 1;
    }

    let budgetCode = '';

    if (this.budgetData) {
      budgetCode = this.budgetData.external_code.split("/")[1] + "/" + this.budgetData.external_code.split("/")[2];
    }

    var textLegal = this.buyOrderHeaderData.terms.split("-");
    textLegal.shift();

    const found = this.listProviders.find((element) => {
      // tslint:disable-next-line:triple-equals
      return element.id == this.buyOrderHeaderData.id_provider;
    });
    this.buyOrderHeaderData.provider_name = found.social_reason

    this.listofvaluesService.getLdvByCode('TBWA-INFORMATION').subscribe((resInfo) => {
      const tempData = {
        workOrder: this.workOrderData,
        budgetHeader: this.budgetData,
        buyOrderHeader: this.buyOrderHeaderData,
        details: this.buyOrderDetailData,
        totalPrice: this.buyOrderHeaderPrice,
        taxVal: this.tax_val,
        whitTaxPrice: this.priceWithTax,
        total: this.total,
        taxText: this.tax_text,
        legal: textLegal,
        taxPercentage: this.tax_percentage,
        group: resInfo[0],
        ruc: resInfo[1],
        address: resInfo[2],
        subtotal: this.buyOrderHeaderPrice,
        userCreate: this.buyOrderHeaderData.user_name,
        budgetCode: budgetCode
      };
      console.log(tempData);
      this.dataToSend = tempData;
      this.pdfService.getPDF(tempData, 'ocPDF').subscribe(
        (result: any) => {
          const filename = 'OrdenCompra' + this.buyOrderHeaderData.doc_number + '.pdf';
          fileSaver.saveAs(result, filename);
          this.notifierService.systemNotify({
            title: 'Exito',
            message: 'Se ha descargado el PDF.',
            type: 'success'
          });
        },
        error => {
          console.log(error);
          this.notifierService.systemNotify({
            title: 'Error',
            message: 'Ha ocurrido un error al descargar el PDF',
            type: 'error',
            duration: 5000
          });
        });
    })
  }
  getTableData(result) {

    this.buyOrderHeaderPrice = 0;
    const cloneRows: Array<any> = [...result];

    for (const item of cloneRows) {

      item.created_date = moment(item.created_date).format('DD/MM/YYYY');
      this.buyOrderHeaderPrice += Number(item.price);
      item.price = Number(item.price).toFixed(2);
      item.price_string = this.budgetService.transformNumber(item.price);
    }

    switch (Number(this.buyOrderHeaderData.tax)) {
      case 1:
        this.tax_text = 'IGV';
        this.priceWithTax = this.buyOrderHeaderPrice * 1.18;
        this.tax_val = this.buyOrderHeaderPrice * 0.18;
        this.tax_percentage = '18%';
        break;
      case 2:
        this.tax_text = 'Inafecto';
        this.priceWithTax = this.buyOrderHeaderPrice;
        this.tax_val = 0;
        this.tax_percentage = '0%';
        break;
      case 3:
        this.tax_text = 'Exonerado';
        this.priceWithTax = this.buyOrderHeaderPrice;
        this.tax_val = 0;
        this.tax_percentage = '0%';
        break;
      case 4:
        this.tax_text = 'RH0';
        this.priceWithTax = this.buyOrderHeaderPrice;
        this.tax_val = 0;
        this.tax_percentage = '0%';
        break;
      case 5:
        this.tax_text = 'RH8';
        this.priceWithTax = this.buyOrderHeaderPrice * 0.92;
        this.tax_val = this.buyOrderHeaderPrice * -0.08;
        this.tax_percentage = '-8%';
        break;
      default:
        break;
    }

    this.buyOrderHeaderPrice = Number(this.buyOrderHeaderPrice).toFixed(2);
    this.buyOrderHeaderPrice = this.budgetService.transformNumber(this.buyOrderHeaderPrice);
    this.total = Number(Number(this.priceWithTax) + Number(this.buyOrderHeaderData.others)).toFixed(2);
    this.total = this.budgetService.transformNumber(this.total);
    this.buyOrderHeaderData.others = Number(this.buyOrderHeaderData.others).toFixed(2);
    this.priceWithTax = Number(this.priceWithTax).toFixed(2);
    this.priceWithTax = this.budgetService.transformNumber(this.priceWithTax);
    this.tax_val = Number(this.tax_val).toFixed(2);
    this.tax_val = this.budgetService.transformNumber(this.tax_val);

    this.dataSourceBuyOrderDetail = new LocalDataSource(cloneRows);
    this.tableSettingsBuyOrderDetail = this.copyObject(this.settings);
    if (this.tableDataBuyOrderDetail.columns !== undefined) {
      this.tableSettingsBuyOrderDetail.columns = this.copyObject(this.tableDataBuyOrderDetail.columns);

      this.tableSettingsBuyOrderDetail.columns['price_string'] = {
        'title': this.tableSettingsBuyOrderDetail.columns['price_string'].title, type: 'html', valuePrepareFunction: function (value) {
          return '<div class="numberformat"> ' + value + ' </div>';
        }
      };

      // Se deshabilita los filtros predefinidos para evitar conflictos
      Object.keys(this.tableSettingsBuyOrderDetail.columns).forEach(key => {
        this.tableSettingsBuyOrderDetail.columns[key].filter = true;
      });
    }
  }

  onProviderSelected(provider) {
    this.buyOrderHeaderData.id_provider = provider.id;
    console.log(this.listProviders.filter(item => item.id == provider.id));
    console.log(this.buyOrderHeaderData);
  }

  openCreateObject() {
    this.notifierService.behaviorNotify({
      action: 'register',
      model: 'buyOrder',
      object: { data: {} }
    });
    const deleteDialog = this.dialog.open(CreateBuyOrderModalComponent);
    deleteDialog.afterClosed().subscribe((result: any) => {
      if (result.action_backend === 'C') {
        let found = this.buyOrderDetailData.find((item) => {
          return (item.create_uuid === result.create_uuid);
        });
        if (found) {
          found = result;
        } else {
          this.buyOrderDetailData.push(result);
        }
      } else if (result.action_backend === 'U') {
        let found = this.buyOrderDetailData.find((item) => {
          return (item.id === result.id);
        });
        if (found) {
          found = result;
        }
      }
      this.getTableData(this.buyOrderDetailData);
    });
  }
  
  customAction(event) {

    switch (event.action) {
      case 'editar':
        this.notifierService.behaviorNotify({
          action: 'edit',
          model: 'buyOrder',
          object: { data: event.data }
        });
        const dialogRef = this.dialog.open(CreateBuyOrderModalComponent);
        dialogRef.afterClosed().subscribe((result) => {
          //console.log('event', event);
          if (result) {
            if (event.data.action_backend === 'C') {
              const index = this.buyOrderDetailData.findIndex((item) => {
                return item.create_uuid === event.data.create_uuid;
              });
              if (index) {
                this.buyOrderDetailData.splice(index, 1, event.data);
              }
            } else {
              event.data.action_backend = 'U';
            }
          }
          this.zone.run(() => {
            this.getTableData(this.buyOrderDetailData);
          });
        }, (error) => {
          console.log('error', error);
        });
        break;
      case 'eliminar':
        const deleteDialog = this.dialog.open(AlertComponent, {
          data: {
            icon: 'exclamation-circle',
            iconColor: 'failure',
            title: 'Aviso',
            text: '¿Está seguro que desea eliminar?',
            options: true
          }
        });
        deleteDialog.afterClosed().subscribe((result) => {
          if (result) {
            if (event.data.action_backend === 'C') {
              const index = this.buyOrderDetailData.findIndex((item) => {
                return item.create_uuid === event.data.create_uuid;
              });
              if (index !== undefined) {

                this.buyOrderDetailData.splice(index, 1);
              }
            } else {
              event.data.action_backend = 'D';
              const idToDelete = this.buyOrderDetailData.findIndex((toDelete) => {
                // tslint:disable-next-line:triple-equals
                return toDelete.id == event.data.id;
              });
              this.buyOrderDetailData.splice(idToDelete, 1);
            }
          }

          this.zone.run(() => {
            this.getTableData(this.buyOrderDetailData);
          });
        }, (error) => {
          console.log('error', error);
        });
        break;
    }


  }

  createBuyOrder(form: NgForm) {
    if (form.valid) {
      console.log('to create', this.buyOrderHeaderData);
      this.buyOrderService.createBuyOrderHeader(this.buyOrderHeaderData).subscribe((result: any) => {
        this.buyOrderDetailData.forEach(element => {
          element.id_buy_order_header = result.id;
        });
        this.buyOrderService.insertBatch(this.buyOrderDetailData).subscribe((listDetail) => {
          this.routes.navigate(['system/buy-order/edit/' + result.id]);
          this.notifierService.systemNotify({
            title: 'Éxito',
            message: 'Se ha creado la Orden de Compra',
            type: 'success'
          });
        }, (error) => {
          this.notifierService.systemNotify({
            title: 'Ha ocurrido un error',
            message: 'Por favor póngase en contacto con el administrador',
            type: 'error'
          });
        });
      });
    } else {
      this.notifierService.systemNotify({
        title: 'Ha ocurrido un error',
        message: 'Por favor llene los campos obligatorios',
        type: 'error'
      });
    }
  }

  updateBuyOrder(form: NgForm) {
    if (form.valid) {
      this.buyOrderService.updateBuyOrderHeader(this.buyOrderHeaderData).subscribe((updateData) => {
        this.buyOrderDetailData.forEach(element => {
          element.id_buy_order_header = this.paramId;
        });
        if (this.buyOrderDetailData.length > 0) {
          this.buyOrderService.InsertAllDetails(this.buyOrderDetailData, this.paramId).subscribe((listDetail) => {
            this.notifierService.systemNotify({
              title: 'Éxito',
              message: 'Se ha actualizado la Orden de Compra',
              type: 'success'
            });
            this.routes.navigate(['system/buy-order/edit/' + this.paramId]);
          }, (error) => {
            this.notifierService.systemNotify({
              title: 'Ha ocurrido un error',
              message: 'Por favor póngase en contacto con el administrador',
              type: 'error'
            });
          });
        } else {
          this.notifierService.systemNotify({
            title: 'Éxito',
            message: 'Se ha actualizado la Orden de Compra',
            type: 'success'
          });
          this.routes.navigate(['system/buy-order/list']);
        }
      });
    }
  }



  sendMail() {

    this.buyOrderHeaderData.created_date = new Date(this.buyOrderHeaderData.created_date).toLocaleString().split(" ")[0];

    for (let index = 0; index < this.buyOrderDetailData.length; index++) {
      this.buyOrderDetailData[index].index = index + 1;
    }

    var textLegal = this.buyOrderHeaderData.terms.split("-");
    textLegal.shift();

    const found = this.listProviders.find((element) => {
      // tslint:disable-next-line:triple-equals
      return element.id == this.buyOrderHeaderData.id_provider;
    });
    this.buyOrderHeaderData.provider_name = found.comercial_name

    this.listofvaluesService.getLdvByCode('TBWA-INFORMATION').subscribe((resInfo) => {
      const tempData = {
        workOrder: this.workOrderData,
        budgetHeader: this.budgetData,
        buyOrderHeader: this.buyOrderHeaderData,
        details: this.buyOrderDetailData,
        totalPrice: this.buyOrderHeaderPrice,
        taxVal: this.tax_val,
        whitTaxPrice: this.priceWithTax,
        taxText: this.tax_text,
        legal: textLegal,
        taxPercentage: this.tax_percentage,
        group: resInfo[0],
        ruc: resInfo[1],
        address: resInfo[2],
        subtotal: this.buyOrderHeaderPrice,
        userCreate: this.buyOrderHeaderData.user_name
      };

      this.buyOrderService.sendMail(tempData, this.provider_email).subscribe((result) => {
        this.notifierService.systemNotify({
          title: 'Éxito',
          message: 'Se ha enviado el correo al proveedor',
          type: 'success'
        });
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/system/buy-order/new-buy-order/new-buy-order.component.ts